import axios from "axios";

export default axios.create({
    baseURL: process.env.REACT_APP_BEDS_API_URL,
    crossDomain: true,
    headers: {
        'Content-type': 'application/x-www-form-urlencoded',
        "Accept": "application/json"
    }
})